/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
/**
 * @description 延时
 * @param duration 毫秒 ms
 * @example
 * ```typescript
 *  await delay(2000);
 * ```
 */
var delay = function (duration) {
    return new Promise(function (resolved) {
        setTimeout(function () {
            resolved('done');
        }, duration);
    });
};

export { delay as d };
